<template>
  <Accordion :error="$v.taxInformation.$error" id="taxInformation" title="INFORMAÇÕES FISCAIS">
    <b-row class="row-padding">
      <b-col lg="5" md="12">
        <SelectWithSearch
          id="natureza"
          label="Natureza"
          labelBusca="descricao"
          placeholder="Pesquise uma natureza"
          ref="searchNatureza"
          v-model="taxInformation.natureza"
          :error="$v.taxInformation.natureza.$error"
          :options="naturezaCollection"
          :change="changeNaturezaSelected"
        >
          <template slot="no-options">Nenhuma natureza encontrada</template>
          <template slot="options" slot-scope="props">
            <div class="selected">
              {{ props.data.descricao }}
            </div>
          </template>
          <template slot="selected" slot-scope="props">
            <div class="selected" style="text-transform: uppercase">
              {{ props.data.descricao }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>

      <b-col lg="2" md="4">
        <Label>CFOP:</Label>
        <Input id="cfop" :value="taxInformation.natureza.cfop.codigo" disabled />
      </b-col>

      <b-col lg="3" md="4">
        <Label>Número:</Label>
        <Input
          id="nfeNumber"
          aria-required="true"
          placeholder="Nº NFE"
          :mask="[nfeNumberMask]"
          v-model="taxInformation.nfeNumber"
          :error="$v.taxInformation.nfeNumber.$error"
        />
      </b-col>
      <b-col lg="2" md="4">
        <Label>Data Entrada:</Label>
        <InputDate
          id="entryDate"
          aria-required="true"
          format="DD/MM/YYYY"
          :range="false"
          v-model="taxInformation.entryDate"
          :error="$v.taxInformation.entryDate.$error"
        />
      </b-col>
    </b-row>
    <b-row class="row-padding pt-0">
      <b-col md="6" lg="3">
        <SelectWithSearch
          id="buyer"
          labelBusca="name"
          label="Comprador:"
          placeholder="Selecione um comprador"
          inputClass="search-buyer"
          ref="searchBuyer"
          v-model="taxInformation.buyer"
          :error="$v.taxInformation.buyer.$error"
          :options="buyerCollectionData"
          :change="changeBuyerSelected"
        >
          <template slot="no-options">Nenhum comprador encontrado</template>
          <template slot="options" slot-scope="props">
            <div class="selected" style="text-transform: uppercase">
              {{ props.data.name }}
            </div>
          </template>
          <template slot="selected" slot-scope="props">
            <div class="selected" style="text-transform: uppercase">
              {{ props.data.name }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col md="6" lg="5">
        <Label>Chave:</Label>
        <Input
          id="nfeKey"
          placeholder="Informe a chave de acesso"
          v-model="taxInformation.nfeKey"
          :error="$v.taxInformation.nfeKey.$error"
          :mask="[nfeKeyMask]"
        />
      </b-col>
      <b-col md="4" lg="1">
        <Label>Série:</Label>
        <Input
          id="nfeSerie"
          placeholder="1"
          v-model="taxInformation.nfeSerie"
          :mask="['XXX']"
          :error="$v.taxInformation.nfeSerie.$error"
        />
      </b-col>
      <b-col md="4" lg="1">
        <Label>Modelo:</Label>
        <Input
          id="nfeModel"
          placeholder="55"
          v-model="taxInformation.nfeModel"
          :mask="['XX']"
          :error="$v.taxInformation.nfeModel.$error"
          @blur="checkIfIsACte"
        />
      </b-col>
      <b-col md="4" lg="2">
        <Label>Data Emissão:</Label>
        <InputDate
          id="issueDate"
          aria-required="true"
          format="DD/MM/YYYY"
          :range="false"
          v-model="taxInformation.issueDate"
          :error="$v.taxInformation.issueDate.$error"
        />
      </b-col>
    </b-row>
    <ModalConfirmCFOP />
  </Accordion>
</template>

<script>
import { Accordion } from '@/components';
import { mapState, mapActions, mapGetters } from 'vuex';
import { SelectWithSearch, Label, Input, InputDate } from '@/components/Form';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import FiscalMixin from '@/modules/Fiscal/mixins/FiscalMixin';
import { required, isValidDate, minLength } from './validations';
import ModalConfirmCFOP from '../../Modals/ModalConfirmCFOP/ModalConfirmCFOP';
import { MODELO } from '../../../../../../Fiscal/enums/Documento';
import { EntryCfop } from '../../../../../../Fiscal/enums/Cfop';

export default {
  name: 'taxInformation',
  components: {
    Accordion,
    SelectWithSearch,
    Label,
    Input,
    InputDate,
    ModalConfirmCFOP,
  },
  validations: {
    taxInformation: {
      natureza: {
        cfop: {
          id: {
            required,
          },
        },
      },
      buyer: {
        required,
      },
      nfeNumber: {
        required,
      },
      nfeModel: {
        required,
      },
      nfeSerie: {
        required,
      },
      nfeKey: {
        minLength: minLength(44),
      },
      entryDate: {
        isValidDate,
      },
      issueDate: {
        isValidDate,
      },
    },
  },
  mixins: [FormatMixin, FiscalMixin],
  data() {
    return {
      nfeKeyMask: 'UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU',
      nfeNumberMask: '##########',
      buyerCollectionData: [],
    };
  },
  async mounted() {
    if (!this.isEditing) {
      await this.setEmptyNatureza();
      this.taxInformation.entryDate = new Date();
      this.taxInformation.issueDate = new Date();
    }
    await this.setNaturezaCollectionForPurchase();
    await this.setNatureza();
    await this.setCurrentBuyer();
    await this.getUsersClient();
    this.buyerCollectionData = await this.usersClient;
  },
  computed: {
    ...mapState('purchase', ['taxInformation', 'supplierInformation', 'purchase']),
    ...mapState('natureza', ['naturezaCollection']),
    ...mapState('client', ['usersClient', 'currentUser']),
    ...mapGetters('purchase', ['getDefaultBuyerState', 'getDefaultNaturezaCfopState', 'isEditing']),
  },
  methods: {
    ...mapActions('natureza', ['setNaturezaCollectionForPurchase']),
    ...mapActions('purchase', [
      'setPurchase',
      'setSelectedNatureza',
      'setMatchedCfopForPurchaseTaxInformation',
    ]),
    ...mapActions('application', ['setLoading']),
    ...mapActions('client', ['getUsersClient', 'getCurrentUser']),
    ...mapActions('componentsPurchase', ['toggleModalChangeCFOP']),
    setEmptyNatureza() {
      this.taxInformation.natureza = [];
      this.taxInformation.natureza.cfop = this.getDefaultNaturezaCfopState;
    },
    async setNatureza() {
      if (!this.taxInformation.natureza?.id) {
        const lastNaturezaId = window.localStorage.getItem('lastPurchaseNaturezaId');
        if (lastNaturezaId) {
          const lastNatureza = this.naturezaCollection.find(
            (e) => e.id === parseInt(lastNaturezaId, 10),
          );
          this.changeNaturezaSelected(lastNatureza, false);
        }
      }
    },
    changeNaturezaSelected(selectedNatureza, manualChange = true) {
      if (selectedNatureza && manualChange) {
        this.setSelectedNatureza(selectedNatureza);
        this.toggleModalChangeCFOP();
        this.checkIfIsACte();
        return;
      }

      if (selectedNatureza) {
        this.buildTaxInformationCfop(selectedNatureza);
        this.taxInformation.natureza = {
          ...selectedNatureza,
        };
        this.checkIfIsACte();
        return;
      }

      this.setEmptyNatureza();
    },
    buildTaxInformationCfop(selectedNatureza) {
      if (!this.supplierInformation.supplier.id) return;

      this.setMatchedCfopForPurchaseTaxInformation({
        supplierId: this.supplierInformation.supplier.id,
        cfopIdPurchaseHeader: selectedNatureza.cfop.id,
      });
    },
    async setCurrentBuyer() {
      await this.getCurrentUser();
      this.changeBuyerSelected(this.currentUser);
    },
    serializeBuyer(buyer) {
      if (!buyer) return null;

      return buyer.id;
    },
    changeBuyerSelected(selectedBuyer) {
      if (selectedBuyer) {
        this.taxInformation.buyer = selectedBuyer;
        this.taxInformation.buyerId = this.serializeBuyer(selectedBuyer);
        return;
      }

      this.taxInformation.buyer = this.getDefaultBuyerState;
      this.taxInformation.buyerId = null;
    },
    checkIfIsACte() {
      const {
        nfeKey,
        nfeModel,
        natureza: {
          cfop: { codigo: cfop },
        },
      } = this.taxInformation;

      const cfopsWatched = ['350', '351', '352', '353', '354', '355', '356', '360'];
      const cfopsWithOperationCode = this.putTypeOperationInCFOP(EntryCfop, cfopsWatched);

      if (nfeModel === MODELO.CTE && cfopsWithOperationCode.includes(cfop)) {
        if (!nfeKey) {
          this.$alert.warning('A chave de acesso deve ser preenchida para o modelo 57 (CTe)');
        }
      }
    },
  },
  watch: {
    taxInformation: {
      handler() {
        this.purchase.taxInformation = this.taxInformation;
      },
      deep: true,
    },
  },
};
</script>
